require('./expensesSummaryBoxRow.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @utilities
const { formatText } = require('core/i18n').i18n;
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { getCategoryIcon } = require('utilities/expensesByCategories/categoriesUtilities');


class ExpensesSummaryBoxCategory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ellipsisActive: false
        };
        this.categoryRef = React.createRef();
    }

    isEllipsisActive = (e) => {
        return (e.offsetWidth < e.scrollWidth);
    }

    handleOnMouseEnter = () => {
        this.isEllipsisActive(this.categoryRef.current) && this.setState((prevState) => {if (prevState.ellipsisActive!==true) return {ellipsisActive: true}});
    }

    render() {   
        const { ellipsisActive } = this.state;
        const { category, prevValues, maxExpenses, currency } = this.props;

        let categoryPrev = false;
        let barPrevStyle = {display: "none"};
        if (!!prevValues && prevValues.length > 0) {
            categoryPrev = prevValues.find(cat => cat[0]=== category[0]) || [category[0], 0];
            barPrevStyle = {width: `${categoryPrev[1] * 100 / maxExpenses()}%`};
        }
        const barCurrentStyle = {width: `${category[1] * 100 / maxExpenses()}%`};
        const prevAmonut = !!prevValues && <span className="previous">{formatAmount(categoryPrev[1])}{' '}{formatCurrency(currency)}</span>;
        const iconClass = getCategoryIcon(category[0]);
        const categoryKey = `categorized-category_${category[0]}`;
        const categoryText = <span ref={this.categoryRef} className="expenses-summary-box__row--category--text" onMouseEnter={()=> this.handleOnMouseEnter()}>{formatText(categoryKey)}</span>;
        const categoryTooltip = <OKTooltip content={`categorized-category_${category[0]}`} offset={[0, -15]} target={categoryText}/>
        const categoryTitle = ellipsisActive ? categoryTooltip : categoryText;

        return ( 
            <React.Fragment>
                <div className="expenses-summary-box__row expenses-summary-box__row--icon">
                    <i className={iconClass} />
                </div>
                <div className="expenses-summary-box__row expenses-summary-box__row--category" >
                    <OKLink extraClass="expenses-summary-box__row--category-link" to="/myprofile/global/expenses-by-category/" modifier="widget">
                        
                        {categoryTitle}
                       
                    </OKLink>
                    <div className="expenses-summary-box__row--category--bar" style={barCurrentStyle}></div>
                    <div className="expenses-summary-box__row--category--bar prev" style={barPrevStyle}></div>
                </div>
                <div className="expenses-summary-box__row expenses-summary-box__row--amount">
                    <span>{formatAmount(category[1])}{' '}{formatCurrency(currency)}</span>
                    {prevAmonut}
                </div>
            </React.Fragment>
        );
    }
}

ExpensesSummaryBoxCategory.propTypes = {
    category: PropTypes.array.isRequired,
    currency: PropTypes.string.isRequired,
    maxExpenses: PropTypes.func.isRequired,
    prevValues: PropTypes.arrayOf(PropTypes.array),
};

export default ExpensesSummaryBoxCategory;